export default __webpack_public_path__ + "static/media/Active_Product.8c3b4b73.svg";